import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {GradeToString} from "../students/list";
import {CheckIcon, SearchIcon, ThinTimeIcon} from "../../../components/icons/material-icons";

interface consultProfileInterface {
    id: number,
    name: string,
    class: string,
    grade: number,
    profile: boolean,
    requests: number,
}

export const AdminsConsultProfilesList = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState<consultProfileInterface[]>([]);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/consult/profiles/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: consultProfileInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "فرم های اطلاعات | مشاوره | اتوماسیون";
        fetchList();
    }, []);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || list.length < 1)
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.table-for-consult-profiles');
        const btns = (lst as HTMLDivElement).getElementsByTagName('tr');
        for (let i = 0; i < btns.length; i++) {

            const b = btns[i].getElementsByTagName('span')[0];
            if (typeof b === "undefined")
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ', '');
            const v2 = btns[i].innerHTML.toUpperCase();
            const noSpace2 = v2.replaceAll(' ', '');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ', '')) > -1 || v2.indexOf(filter) > -1 || noSpace2.indexOf(filter.replaceAll(' ', '')) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مشاوره', url: '/admins/consult'},
                {title: 'فرم‌های اطلاعات', url: '/admins/consult/profiles'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>فهرست دانش‌آموزان</b>
                            </div>
                            <div className="pick-device-search">
                                <button><SearchIcon/></button>
                                <input type="text"
                                       value={search}
                                       onChange={e => setSearch(StringDigitsConvertToPersian(e.currentTarget.value))}
                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                       className="f-roboto"
                                       placeholder={"جستجو در میان دانش‌آموزان..."}
                                />
                            </div>
                            <table className="table open-table table-hover table-striped table-bordered table-for-consult-profiles">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>دانش‌آموز</th>
                                    <th>کلاس</th>
                                    <th>پایه</th>
                                    <th>وضعیت</th>
                                    <th>درخواست‌ها</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((d, i) =>
                                        <tr key={"Hx233Xx_" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                {d.profile ?
                                                    <Link to={`/admins/consult/profiles/view/${d.id}`}>
                                                        <span>{d.name}</span>
                                                    </Link> : <span>{d.name}</span>
                                                }
                                            </td>
                                            <td><span>{d.class === '' ? '-' : d.class}</span></td>
                                            <td><span>{GradeToString(d.grade)}</span></td>
                                            <td>
                                                {
                                                    d.profile ?
                                                        <em data-color="green"><CheckIcon/>تکمیل شده</em> :
                                                        <em data-color="red"><ThinTimeIcon/>تکمیل نشده</em>
                                                }
                                            </td>
                                            <td><span>{d.requests < 1 ? '-' : `${CurrencyFormat(d.requests)} درخواست`}</span></td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
        </>
    );
};